import * as types from './mutation_types';

export default {
  [types.SET_APP_NEWS](state, messages) {
    state.messages = messages;
  },
};
